import { useGetOfferingEntitlementsQuery } from '../check-entitlements/useGetOfferingEntitlementsQuery';
import { useCheckInstitutionalIndicationAccess } from './useCheckInstitutionalIndicationAccess';

type AccessCheckResult = {
  canRead: boolean;
  canUpdate: boolean;
  isSellSideAccount: boolean;
  loading: boolean;
};

/**
 * Checks accessibility of an Institutional Indication.
 */
export function useGetPublishedOfferingEntitlementsAndCheckInstitutionalIndicationAccess({
  offeringId,
}: {
  offeringId?: string;
}): AccessCheckResult {
  const { data: entitlements, loading } = useGetOfferingEntitlementsQuery({ offeringId });

  const { isSellSideAccount, ...accessChecks } = useCheckInstitutionalIndicationAccess({
    entitlements,
  });

  return { loading, ...accessChecks, isSellSideAccount };
}
